import {Outlet, createRootRouteWithContext} from '@tanstack/react-router';

import type {QueryClient} from '@tanstack/react-query';
import type {PublicClientApplication} from '@azure/msal-browser';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
  msal: PublicClientApplication;
}>()({
  component: Outlet,
});
